import React from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import { PageHeader } from '../components/common'
import SessionSchedulingCalendar from '../components/sessions/SessionSchedulingCalendar'

const RescheduleSession = () => {
  const history = useHistory()
  const location = useLocation()
  const scheduledSession = location.state?.scheduledSession

  const renderHelmet = () => (
    <Helmet>
      <title>{'Reschedule Session | Abroad'}</title>
      <meta name='title' content={'Reschedule Session | Abroad'}></meta>
      <meta property='og:title' content={'Reschedule Session | Abroad'}></meta>
      <meta
        property='twitter:title'
        content={'Reschedule Session | Abroad'}></meta>
      <link
        rel='canonical'
        href={`${process.env.REACT_APP_DOMAIN}/coaching/sessions/reschedule`}></link>
      <meta
        property='og:url'
        content={`${process.env.REACT_APP_DOMAIN}/coaching/sessions/reschedule`}></meta>
      <meta
        property='twitter:url'
        content={`${process.env.REACT_APP_DOMAIN}/coaching/sessions/reschedule`}></meta>
    </Helmet>
  )

  const handleScheduleSuccess = (event) => {
    history.push('/coaching/sessions', {
      rescheduledEvent: event,
    })
  }

  return (
    <>
      {renderHelmet()}
      <PageHeader
        title='Sessions'
        version='small'
        backArrowAction={() => history.push('/coaching/sessions')}
        showBackArrow={true}
      />
      <SessionSchedulingCalendar
        schedulingType='reschedule'
        scheduledSession={scheduledSession}
        onScheduleSuccess={handleScheduleSuccess}
      />
    </>
  )
}

export default RescheduleSession
